// store/imagesSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchImagesByPet = createAsyncThunk(
  "images/fetchByPet",
  async (_, thunkAPI) => {
    const state = thunkAPI.getState();
    const activePet = state.activePet;
    if (!activePet) return [];
    try {
      const resp = await axios.get("/getimagesbypetid", {
        params: { id: activePet.name },
      });
      return resp.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || "Error loading images");
    }
  }
);

const imagesSlice = createSlice({
  name: "images",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchImagesByPet.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchImagesByPet.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchImagesByPet.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default imagesSlice.reducer;
